"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EscrowAccount = void 0;
const Field_type_1 = require("../../../types/Field.type");
const EscrowAccount_1 = require("../../enm/EscrowAccount");
exports.EscrowAccount = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.escrow_account.label',
    fallbackLabel: 'Are the funds received from Klarna and before disbursement to merchants, safeguarded in a separate, bankruptcy-remote escrow account (or similar)?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.Enum,
    options: EscrowAccount_1.EscrowAccountRef.options,
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
